import React, { PureComponent } from 'react';
import { Card, Pagination } from 'element-react';
import message01 from 'images/soldier/message1.png';
import { Link } from 'react-router-dom';
import Paging from 'components/Paging'
import NoDataPicture from 'components/NoDataPicture'
import NoDataList from 'components/NoDataList'

import './outter.css'

export default class Outter extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data
        };

    }
    componentWillReceiveProps(newProps) {
        let { data } = this.state;
        if (data != newProps.data) {
            this.setState({
                data: newProps.data
            })
        }
    }

    getCurrentChange(data){
        console.log("分页onCurrentChange:",data);
      
    }
    render() {
        const { data } = this.state;
        return (
            <div className="outter clear">
                <div className="clear" style={{ minHeight: '500px' }}>
                    {
                        data.length != 0 ? data.records.map(childItem => {
                            return (
                                <Card key={childItem.id}>
                                    <Link to={'/entrance/soldierDetail?' + `${childItem.id}`}>
                                        {
                                            childItem.image == '' ? <NoDataPicture /> :
                                            <img src={childItem.image} />
                                        }
                                    </Link>
                                    <div className="card_title">{childItem.title}</div>
                                </Card>
                            )
                        }) :
                        <NoDataList />
                    }
                </div>
                {
                    data.length != 0 ? <Paging showSizes={true} total={data.total} pageSize={data.size} currentPage={data.current} onCurrentChange={this.getCurrentChange.bind(this)}/> : null
                }
                
            </div>
        )
    }
}
